import React, { useEffect, useState } from 'react'
import axios from 'axios';
import CandidateHeader from '../Candidate/Candidate Navbar/Header'
import  avatar from '../../assets/profile-avatar.png'
import './StudentRegistration.css'
import validation from "./Student_Registration_Validation";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faUser,faEnvelope,faPhone,faHouse,faLocationDot,faIndianRupeeSign } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import { Helmet } from 'react-helmet';

function StudentRegistration() {
  const navigate = useNavigate();
  const [inputs, setInput] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    gender:"",
    district:"",
    state: '',
    pin: "",
    course: "",
    modeofTraining: "",
    photo: "",
    aadhaar: "",
    resume: "",
    amount: 1000,
});

const [errors, setErrors] = useState({});

const[state, setState] = useState([
        {
          id:null,
          state_name:null
        }
]);

const[district, setDistrict] = useState([
  {
    id:null,
    district_name:null
  }
]);
const[course, setCourse] = useState([
  {
    id:null,
    course_name:null
  }
]);

const modeofTrainingoptions = [
  { value: 'Online', label: 'Online' },
  { value: 'Offline', label: 'Offline' },
];

const [profimg, setProfImg] = useState(""); //for display image after upload




useEffect(()=>{
    document.title = "Aspire Student Registration"; 
    const metaTag = document.querySelector('meta[property="og:title"]');
    if (metaTag) {
      metaTag.setAttribute('content', 'Aspire student registration');
    }
   
    fetchStateList();
    fetchDistrictList();
    fetchCourseList();

   
    // const link = document.querySelector('link[rel="icon"]');
    // const newLink = document.createElement('link');
    // newLink.rel = 'icon';
    // newLink.href = '';
    // document.head.appendChild(newLink);
    // link.remove();

},[])

const fetchStateList = () =>{
  axios.get('https://pl.aspireitacademy.com/state-api').then((response)=>{
    setState (response.data);
  }).catch( error => {
    
    toast.error("Something went wrong")  ;
  })
}

const fetchDistrictList = () =>{
  axios.get('https://pl.aspireitacademy.com/district-api').then((response)=>{
    setDistrict (response.data);
  }).catch( error => {
       toast.error("Something went wrong")  ;
  })
}
const fetchCourseList = () =>{
  axios.get('https://pl.aspireitacademy.com/academycourse-api').then((response)=>{
    setCourse (response.data);
  }).catch( error => {
      toast.error("Something went wrong")  ;
  })
}


//prevent form submitting
const handleSubmit = (e) => {
  e.preventDefault();
}
const handleChange = (e) => {
  setInput({ ...inputs, [e.target.name]: e.target.value })
  setErrors( { ...errors, [e.target.name]: "" });
 
};

const handleFileUpload = (e)=>{
  setInput({ ...inputs, [e.target.name]: e.target.files[0] })
  setErrors( { ...errors, [e.target.name]: "" });
}

//for display image after upload
const handleImgUpload = (e)=>{
  setProfImg(URL.createObjectURL(e.target.files[0]));
  setInput({ ...inputs, [e.target.name]: e.target.files[0] })
  setErrors( { ...errors, [e.target.name]: "" });
}

  //=======================put api for update candidate details=============================
  const StudReg = () => {
  const validationstatus = validation(inputs);
  if (!validationstatus.status) {
   // topRef.current.scrollTop = 0;
    window.scrollTo(0, 0)
    setErrors(validationstatus.errors);
    // Scroll to the top of the page
     
  } else{
       razroPayment();
    }
}

//razro payment integration
  const razroPayment = () =>{
   const options ={
    //  key:'rzp_test_S8YUv77INNHaZb',  TestMode
    //  key_secret:'QA6TQ9xaN2oUETfmlzgP1QfT', TestMode

      key:'rzp_live_1sTiWj2cDpLq5P',
      key_secret:'MuvM4HBZdOaHthD6FR9VV9RC',
      amount: inputs.amount * 100, // amount in paise
      currency: 'INR',
      name:'Aspire IT Academy',
      descrition:'For testing purpose',
      handler:function (response) {
       if(response.razorpay_payment_id !== ''){
          addStudentData(response.razorpay_payment_id);
       }
      },
      prefill: {
        name: inputs.name,
        email: inputs.email,
        contact: inputs.phone,

      }
   };
    const rzp = new window.Razorpay(options);
    rzp.open();
    rzp.on('payment.error', function (error) {
      console.log('payment failed')
    });
  }



const addStudentData = (paymntid) => {
  
    const data = new FormData() 
    data.append('name', inputs.name);
    data.append('phone', inputs.phone);
    data.append('email', inputs.email);
    data.append('district', inputs.district);
    data.append('state', inputs.state);
    data.append('pin', inputs.pin);
    data.append('course', inputs.course);
    data.append('mode_of_training', inputs.modeofTraining);
    data.append('photo', inputs.photo);
    data.append('aadhaar', inputs.aadhaar);
    data.append('resume', inputs.resume);
    data.append('amount', inputs.amount);
    data.append('address', inputs.address);
    data.append('gender', inputs.gender);

  
    axios.post(`https://pl.aspireitacademy.com/student-add-api`,data,{

    }).then(res => {
       
        if(res.data === "The data has been successfully inserted"){
          navigate('/registration-success',{
            state:{
              txnId: paymntid,
              amount: inputs.amount,
            }
          });
          
        }else{
          navigate('/registration-failed');
        }
    }).catch(function (error) {
        navigate('/registration-failed');
    })
}


const handlesStateChange = (selectedOption) => {
  setInput(selectedOption ? { ...inputs, state: selectedOption.id } : null);
  setErrors( { ...errors, state: "" });
};
const handleDistrictChange = (selectedOption) => {
  setInput(selectedOption ? { ...inputs, district: selectedOption.id } : null);
  setErrors( { ...errors, district: "" });
};
const hadleCourseChange = (selectedOption) => {
  setInput(selectedOption ? { ...inputs, course: selectedOption.id } : null);
  setErrors( { ...errors, course: "" });
};
const hadleModeTrainingChange = (selectedOption) => {
  setInput(selectedOption ? { ...inputs, modeofTraining: selectedOption.value } : null);
  setErrors( { ...errors, course: "" });
};

//select box style
const customStyles = {
  control: (provided,state) => ({
    ...provided,
    minHeight: '44px', 
  
  }),
};
  return (
    <section >
  {/* <Helmet>
          <title>Aspire Student Registration</title>
          <meta name="description" content="#1 Python, .Net, Software Testing, Digital Marketing & Corporate training institute in Kochi with live class & 100% placement support. For Demo Class Call Now!" />
          <meta property="og:title" content="Aspire Student Registration" />
          <meta name="twitter:title" content="Aspire Student Registration" />

    </Helmet> */}
    <CandidateHeader/>
       <div className="container-fluid py-4 stud_reg_container"  style={{backgroundColor:"#f4f4f4"}}>
       
    <form id='stud_reg_form' onSubmit={handleSubmit} >
       
 <div className="student-reg-input-container py-5  px-sm-4 " > 
 <h3 className='text-center mb-3'>Student Registration</h3>
 <div className="text-center mb-3"  >
            <div className="profile-upload">
              <label htmlFor="avatar-upload" className="avatar-img-wrapper">
              <img src={profimg?profimg:avatar} alt="Profile Avatar" className="avatar-img rounded-circle" 
              width="170px" height="170px"/>
              <div className="upload-icon">
              <i className="fa fa-camera"></i>
              </div>
              </label>
              <input id="avatar-upload" name="photo" type="file" accept="image/*"  onChange={handleImgUpload} style={{display:'none'}}/>
            </div>
            <span className="reg-error-msg">{errors.photo ? errors.photo : ""}</span>
        </div>
  <div className="row gy-3 gx-4 px-sm-5 px-3" >
  <div className="col-md-6 ">
        <label htmlFor="inputname" className="form-label">Name</label>
        <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text input-prefix"  >
                 <FontAwesomeIcon icon={faUser} style={{color: "#ffffff",}} />
              </span>
            </div>
            <input type="text" 
                  
                  className="form-control" 
                  id="inputname"
                  placeholder="Enter Name"
                  name="name" 
                  onChange={(e)=>{handleChange(e)}}
                  value={inputs.name?inputs.name:''} 
                  />
        </div>
       
       <span className="reg-error-msg">{errors.name ? errors.name : ""}</span>
  </div>
  <div className="col-md-6">
  <label htmlFor="gender" className="form-label text-start">Gender</label>
     
      <div>
      <div className="form-check form-check-inline">
          <input type="radio" className="form-check-input" name="gender" onChange={(e)=>{handleChange(e)}} 
          checked={inputs.gender === "M" || inputs.gender === "m" || inputs.gender === false}value='M' />
          <label className="form-check-label" htmlFor="radio1" style={{color:'#000'}}>Male</label>
      </div>
      <div className="form-check form-check-inline ms-3">
          <input type="radio" className="form-check-input" name="gender" onChange={(e)=>{handleChange(e)}} 
         checked={inputs.gender === "F" || inputs.gender === "f" || inputs.gender === false}  value='F' />
          <label className="form-check-label" htmlFor="radio2" style={{color:'#000'}} >Female</label>
      </div>
      <div className="form-check form-check-inline ms-3">
          <input type="radio" className="form-check-input" name="gender" onChange={(e)=>{handleChange(e)}} 
         checked={inputs.gender === "O" || inputs.gender === "o" || inputs.gender === false}  value='O' />
          <label className="form-check-label" htmlFor="radio3" style={{color:'#000'}} >Other</label>
      </div>
      
      </div>
      <span className="reg-error-msg">{errors.gender ? errors.gender : ""} </span>

  </div>
  <div className="col-md-6">
              <label htmlFor="inputemai" className="form-label">Email</label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text input-prefix"  >
                    <FontAwesomeIcon icon={faEnvelope} style={{color: "#ffffff",}} />
                  </span>
                </div>
                  <input type="email" 
                          id='inputemai'
                            className="form-control"
                            placeholder="Enter Email" 
                            name="email" 
                            onChange={(e)=>{handleChange(e)}}
                            value={inputs.email?inputs.email:''} />
               </div>
               <span className="reg-error-msg">{errors.email ? errors.email : ""}</span>
  </div>
  <div className="col-md-6">
               <label htmlFor="inputmob" className="form-label">Mobile</label>
               <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text input-prefix"  >
                    <FontAwesomeIcon icon={faPhone} style={{color: "#ffffff",}} />
                  </span>
                </div>
                     <input type="number"
                             className="form-control"
                             placeholder="Enter Phone Number"
                             name="phone"
                             id='inputmob'
                             maxLength={10} 
                             onChange={(e)=>{handleChange(e)}}
                             value={inputs.phone?inputs.phone:''}
                             />
                  </div>
              <span className="reg-error-msg">{errors.phone ? errors.phone : ""}</span>
  </div>
    <div className="col-md-12">
               <label htmlFor="inputaddress" className="form-label">Address</label>
               <div className="input-group ">
                <div className="input-group-prepend d-none d-sm-block">
                  <span className="input-group-text input-prefix"  >
                    <FontAwesomeIcon icon={faHouse} style={{color: "#ffffff",}} />
                  </span>
                </div>
                     <input type="text"
                             className="form-control d-none d-sm-block"
                             placeholder="Enter Address"
                             name="address"
                             id='inputaddress'
                             onChange={(e)=>{handleChange(e)}}
                             value={inputs.address?inputs.address:''}
                             />
                 </div>
                 <textarea className="form-control d-block d-sm-none" 
                          id="inputaddress" 
                            name="address"
                          rows="4" placeholder="Enter address"
                          onChange={(e)=>{handleChange(e)}}
                          value={inputs.address?inputs.address:''}
                          ></textarea>

              <span className="reg-error-msg">{errors.address ? errors.address : ""}</span>
  </div>
  <div className="col-md-4">
    <label htmlFor="inputState" className="form-label">State</label>

    <Select
         options={state}
         value={state.find((option) => option.id ===  inputs.state)}
        placeholder="Select"
        styles={customStyles}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option ? option.state_name : ""}
        onChange={handlesStateChange}
       
      />

    {/* <select   id="inputState" 
              name='state'
              className="form-select"
              value={inputs.state?inputs.state:''}
              onChange={(e)=>{handleChange(e)}}>
      <option value=''>--Select--</option>

        {
          state && state.map( (item) => (
              <option className='text-capitalize' key={item.id} value={item.id}>
                  {item.state_name}</option>
          ))
        }
    </select> */}
    <span className="reg-error-msg">{errors.state ? errors.state : ""}</span>
  </div>
  <div className="col-md-4">
    <label htmlFor="inputdistrct" className="form-label">District</label>

    <Select
         options={district}
         value={district.find((option) => option.id ===  inputs.district)}
        placeholder="Select"
        styles={customStyles}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option ? option.district_name : ""}
        onChange={handleDistrictChange}
       
      />

    {/* <select id="inputdistrct" 
                className="form-select"
                name='district'
                value={inputs.district?inputs.district:''}
                onChange={(e)=>{handleChange(e)}}>
            <option value = '' >--Select--</option>
            {
          district && district.map( (item) => (
              <option className='text-capitalize' key={item.id} value={item.id}>{item.district_name}</option>
          ))
        }
     </select> */}
    <span className="reg-error-msg">{errors.district ? errors.district : ""}</span>
  </div>
  <div className="col-md-4">
    <label htmlFor="inputZip" className="form-label">Pincode</label>
    <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text input-prefix"  >
                    <FontAwesomeIcon icon={faLocationDot} style={{color: "#ffffff",}} />
                  </span>
                </div>
    <input type="text" 
          className="form-control" 
          id="inputZip" 
          name='pin'
          placeholder='Enter Pincode'
          onChange={(e)=>{handleChange(e)}}
          value={inputs.pin?inputs.pin:''}
          />
    </div>
     <span className="reg-error-msg">{errors.pin ? errors.pin : ""}</span>
  </div>
  <div className="col-md-4">
      <label htmlFor="inputCourse" className="form-label">Course</label>
      <Select
         options={course}
         value={course.find((option) => option.id ===  inputs.course)}
        placeholder="Select"
        styles={customStyles}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option ? option.course_name : ""}
        onChange={hadleCourseChange}
       
      />




      {/* <select   id="inputCourse" 
               className="form-select"
                name='course'
                value={inputs.course?inputs.course:''}
                onChange={(e)=>{handleChange(e)}}>  
      <option  value=''>--Select--</option>

        {
          course && course.map( (item) => (
              <option className='text-capitalize' key={item.id} value={item.id}>
                    {item.course_name}</option>
          ))
        }
      </select> */}
      <span className="reg-error-msg">{errors.course ? errors.course : ""}</span>
  </div>
  <div className="col-md-4">
      <label htmlFor="inputModeOfTraining" className="form-label">Mode of Training</label>
      <Select
        options={modeofTrainingoptions}
        value={modeofTrainingoptions.find((option) => option.value === inputs.modeofTraining)}
        placeholder="Select"
        styles={customStyles}
        name='modeofTraining'
        onChange={(e)=>{hadleModeTrainingChange(e)}}
       
      />
      <span className="reg-error-msg">{errors.course ? errors.course : ""}</span>
  </div>
  <div className="col-md-4">
    <label htmlFor="inputFee" className="form-label">Fee Amount</label>
    <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text input-prefix"  >
                    <FontAwesomeIcon icon={faIndianRupeeSign} style={{color: "#ffffff",}} />
                  </span>
                </div>
    <input type="text" 
            className="form-control" 
            id="inputFee" 
            name='amount'
            onChange={(e)=>{handleChange(e)}}
          value={inputs.amount?inputs.amount:''}
          />
      </div>
          <span className="reg-error-msg">{errors.amount ? errors.amount : ""}</span>
  </div>

  <div className="col-md-6">
        <label htmlFor="inputAadhaar" className="form-label">Aadhaar</label>
        <input type="file" className="form-control stud-reg-file-upload" id="inputAadhaar" 
                 accept="image/*"  name='aadhaar' onChange={(e)=>{handleFileUpload(e)}}/>
        <span className="reg-error-msg">{errors.aadhaar ? errors.aadhaar : ""}</span>

  </div>
  <div className="col-md-6">
     <label htmlFor="inputResume" className="form-label">Resume</label>
     <input type="file" className="form-control stud-reg-file-upload" id="inputResume" 
                       accept=".docx,.pdf,.rtf,.doc"
                       name='resume' onChange={(e)=>{handleFileUpload(e)}}/>
      <span className="reg-error-msg">{errors.resume ? errors.resume : ""}</span>
  </div>

  <div className="col-12 text-end mt-4">
    <button type="submit" className="btn btn-primary stud-reg-btn"
            onClick={()=>{StudReg()}}>Register & Pay Now</button>
  </div>
</div>
</div>
       
</form>
       </div>
    </section>
  )
}

export default StudentRegistration